<template>
<div class="buy_ok ">
    <h1 class="b">증표 구입 신청 완료</h1>
    <p>
    <!-- 경유증표 구입 신청이 완료되었습니다. <br/> -->
    하단의 합계 금액을 가상계좌번호로 정확히 입금해야 정상 처리되며, <br/>
    마감기한까지 <B class="red01">미입금 시 구입 신청은 자동취소</B> 됩니다.<br/>
    입금 후, 5분 뒤 사용 가능합니다.
    </p>
    <table class="tbl01 via_form line">
        <tr>
            <th>은행명</th>
            <td>{{ sitem.vrbankcodenm }}</td>
        </tr>
        <tr>
          <th>가상계좌번호</th><!-- 가상계좌번호 : {{ sitem.vrbankcodenm }}, {{ sitem.vraccno }}, {{ sitem.vrmembnm }}<br/> -->
          <td><B>{{ sitem.vraccno | insertHyphen(4,4) }}</B></td>
        </tr>
        <tr>
          <th>예금주</th>
          <td>서울회 경유증표</td>
        </tr>
        <tr>
          <th>마감기한</th>
          <td><B class="red01">구입 신청 시점으로부터 다음날 자정까지<br/>
            {{ sitem.paylimitdt | moment("YYYY.MM.DD. (ddd) HH:mm") }}</B>
          </td>
        </tr>
    </table>
    <table class="tbl01 th_border via_form mt20 pop_buy_ok">
      <tr>
        <th class="viakind">증표 종류</th>
        <th>금액</th>
        <th>수량</th>
        <th>계</th>
      </tr>
      <tr>
        <th>
          본안(일반)<br/>
          <!-- <font class="org01">민사/형사/행정/가사 등</font> -->
        </th>
        <td class="al_amt ">{{ sitem.uprc_1   | comma }} 원</td>
        <td>{{ sitem.numofcase_1 }} 장</td>
        <td class="al_amt">{{ sitem.viafee_1 | comma }} 원</td>
      </tr>
      <tr>
        <th>
          본안(민사소액)<br/>
          <!-- <font class="org01">소가 3,000 만 원 이하</font> -->
        </th>
        <td class="al_amt">{{ sitem.uprc_2   | comma }} 원</td>
        <td>{{ sitem.numofcase_2 }} 장</td>
        <td class="al_amt">{{ sitem.viafee_2 | comma }} 원</td>
      </tr>
      <tr>
        <th>
          본안(민사고액)<br/>
          <!-- <font class="org01">소가 10 억 원 이상</font> -->
        </th>
        <td class="al_amt">{{ sitem.uprc_3   | comma }} 원</td>
        <td>{{ sitem.numofcase_3 }} 장</td>
        <td class="al_amt">{{ sitem.viafee_3 | comma }} 원</td>
      </tr>
      <tr>
        <th>신청</th>
        <td class="al_amt">{{ sitem.uprc_6   | comma }} 원</td>
        <td>{{ sitem.numofcase_6 }} 장</td>
        <td class="al_amt">{{ sitem.viafee_6 | comma }} 원</td>
      </tr>
      <tr>
        <th>등기</th>
        <td class="al_amt">{{ sitem.uprc_7   | comma }} 원</td>
        <td>{{ sitem.numofcase_7 }} 장</td>
        <td class="al_amt">{{ sitem.viafee_7 | comma }} 원</td>
      </tr>
      <tr class="sum">
        <th colspan="2">합계</th>
        <th>{{ sitem.numofcase_1
             + sitem.numofcase_2
             + sitem.numofcase_3
             + sitem.numofcase_6
             + sitem.numofcase_7 | comma }} 장</th>
        <th class="al_amt">{{ sitem.viafee_1
             + sitem.viafee_2
             + sitem.viafee_3
             + sitem.viafee_6
             + sitem.viafee_7 | comma }} 원</th>
      </tr>
    </table>
  </div>
  <!-- </modal> -->
</template>

<script>
let ui
export default {
  data() {
    return {
      modalName: "c증표구입완료_" + T.randomAZ(10),
      sitem : {},

      sellregdt: null,
      sellseq: null,
    }
  },
  created() {
    ui = this.$ui;
  },
  methods: {
    load({sellregdt,sellseq}) {
      this.sellregdt = sellregdt
      this.sellseq = sellseq
      this.getData()
    },
    getData() {
      if (this.sellregdt && this.sellseq) {
        ui.httpGet('/proc/N_SEL_SELLINFO_DTL',
          {
            iv_sellregdt: this.sellregdt,
            iv_sellseq  : this.sellseq,
            iv_accflag    : 'C', // DETAIL 한건 조회
            iv_selldtfr   : '',
            iv_selldtto   : '',
            iv_sellplac   : '',
          },
          ret => {
            // 증표종류가 전체가 아닐 경우 DB에서 받아온 증표 번호 그대로 출력, 아니면 받아온 증표 번호 끝자리 0으로 대체
            this.sitem = ret.data.rs1[0]
          })
      } else {
        this.sitem = {} // props가 빈값이 들어오면 데이터도 비운다.
      }
    },

  },
}
</script>
<style scoped>



</style>